import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as u } from "react";
function l(e) {
  var _u = u(e),
    _u2 = _slicedToArray(_u, 1),
    t = _u2[0];
  return t;
}
export { l as useDefaultValue };